module.exports = __webpack_public_path__ + "img/8.b9de6404.jpg";